import styled, { css } from 'styled-components';

const CHECKBOX_OPTIONS_HEIGHT = '64px';

export const Header = styled.div<{ $hasCheckedTruckers?: boolean }>`
  ${({ theme, $hasCheckedTruckers }) => css`
    display: flex;
    color: ${theme.color.text.neutral.default};
    font-size: ${theme.font.size.m2};
    line-height: ${theme.font.lineHeight.large};
    background-color: ${theme.color.background.neutral.default};
    position: sticky;
    top: ${$hasCheckedTruckers ? CHECKBOX_OPTIONS_HEIGHT : '0'};
    z-index: 10;

    .grid-container.sc-fuel-grid-container-h {
      width: 100%;
      background-color: ${theme.color.background.neutral.weak};
      border-radius: ${theme.border.radius.default};
      margin-left: 0;
      margin-right: 0;
      height: 43px;
    }

    .grid-item {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .grid-item:first-child {
      padding-left: ${theme.spacing.km4};
    }

    .grid-item {
      justify-content: flex-start;
    }
  `}
`;
